export const ADD_TO_DISCORD_URL =
  'https://discord.com/oauth2/authorize?client_id=1481325084835713184&permissions=8&scope=bot+applications.commands';

export const DISCORD_INVITE_URL = 'https://discord.gg/zueuN7xmWx';

export const API_BASE_URL = 'https://api.avbot.app';

export const DISCORD_CLIENT_ID = '1481325084835713184';
